import { render, staticRenderFns } from "./writeDialog.vue?vue&type=template&id=085b8a2d&scoped=true&"
import script from "./writeDialog.vue?vue&type=script&lang=js&"
export * from "./writeDialog.vue?vue&type=script&lang=js&"
import style0 from "./writeDialog.vue?vue&type=style&index=0&id=085b8a2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085b8a2d",
  null
  
)

export default component.exports